<template>
  <div class="tracks-table__row tracks-table__records">
    <div
      class="tracks-table__avatar-cell relative"
    >
      <template v-if="windowWidth < 768">
        <div
          v-if="isPlaying"
          class="flex items-center w-12 h-12"
          @click="togglePlayStatus"
        >
          <mj-audio-player-music-wave
            class="mt-5 ml-2"
          />
        </div>
        <img
          v-else
          :src="track.thumbnail"
          class="rounded-full object-cover w-12 h-12"
          @click="togglePlayStatus"
        >
        <mj-icon
          v-show="track.preview_url && !isPlaying"
          src="music-indicator"
          class="w-4 h-4 text-pink-500 absolute music-indicator__position"
        />
      </template>
      <img
        v-else
        :src="track.thumbnail"
        class="rounded-full object-cover w-12 h-12"
        :class="{ 'cursor-pointer': track.preview_url }"
        @click="togglePlayStatus"
      >
    </div>
    <div class="tracks-table__artists-cell flex flex-col truncate mr-6">
      <span class="text-gray-900 truncate">
        {{ track.track }}
      </span>
      <span class="truncate">
        {{ track.artist }}
      </span>
    </div>
    <div class="tracks-table__album-cell truncate mr-6">
      {{ track.album }}
    </div>
    <div class="tracks-table__time-cell">
      {{ computedDuration }}
    </div>
    <div class="tracks-table__controls-cell flex">
      <div class="tracks-table__player flex-1">
        <mj-audio-player
          v-if="track.preview_url"
          v-model="isPlaying"
          :src="track.preview_url"
        />
      </div>
      <div class="tracks-table__actions">
        <mj-icon
          v-if="isSynchronized"
          src="like-filled"
          class="w-6 h-6 fill-current text-gray-900"
          :class=" {'text-pink-500' : isAdded, 'cursor-pointer': !canNotDetach }"
          @click="add"
        />
        <mj-icon
          v-else
          src="like"
          class="w-6 h-6 fill-current text-gray-900"
          :class=" {'text-pink-500' : isAdded, 'cursor-pointer': !canNotDetach }"
          @click="add"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AudioPlayer from '@/components/audio-player/AudioPlayer.vue';
import AudioPlayerMusicWave from '@/components/audio-player/AudioPlayerMusicWave.vue';

export default {
  name: 'TracksTableRow',

  components: {
    'mj-audio-player': AudioPlayer,
    'mj-audio-player-music-wave': AudioPlayerMusicWave,
  },

  props: {
    track: {
      type: Object,
      required: true,
    },

    storedTracks: {
      type: Array,
      required: true,
      default: () => [],
    },

    windowWidth: {
      type: Number,
      required: false,
      default: () => window.innerWidth,
    },
  },

  data() {
    return {
      isPlaying: false,
    };
  },

  computed: {
    ...mapGetters(['isDefaultUser']),

    isAdded() {
      return this.storedTracks.find(t => t.track_id === this.track.track_id) ? 'text-pink-500' : null;
    },

    isSynchronized() {
      const track = this.storedTracks.find(t => t.track_id === this.track.track_id);
      return this.isAdded && track.is_transferred;
    },

    computedDuration() {
      return (this.track.duration / (60 * 1000)).toFixed(2).replace('.', ':');
    },

    canNotDetach() {
      return !this.isDefaultUser && this.isAdded;
    },

  },

  methods: {
    add() {
      if (this.canNotDetach) return;
      this.$emit('track-selected', this.track);
    },

    togglePlayStatus() {
      if (!this.track.preview_url) return;
      this.isPlaying = !this.isPlaying;
    },
  },
};

</script>

<style lang="scss" scoped>
.music-indicator__position {
  top: -.1rem;
  left: 3rem;
  transform: rotateY(180deg);
}
</style>
